module.exports = __webpack_public_path__ + "static/media/bijaksana_junerosano.9860e13f.jpg";